import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/question.svg'


const _hoisted_1 = { class: "flex flex-row justify-between" }
const _hoisted_2 = { class: "flex flex-row items-start legend-label" }
const _hoisted_3 = {
  key: 1,
  class: "legend-marker mr-2"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 0,
  class: "relative inline-block w-8 mr-2 align-middle select-none transition duration-200 ease-in"
}
const _hoisted_7 = ["name", "id", "checked"]
const _hoisted_8 = ["for"]

import { store } from "@/main"
import { SwitchType } from "@/classes/State"


export default /*#__PURE__*/_defineComponent({
  __name: 'LegendSwitch',
  props: {
    switchable: { type: Boolean },
    checked: { type: Boolean },
    id: {},
    title: {},
    iconName: {},
    color: {},
    tooltip: {}
  },
  setup(__props: any) {


const url = process.env.BASE_URL
function toggle (id: SwitchType) {
  store.toggleSwitch(id)
}
function setInformationTooltip (event: MouseEvent, title: string, text: string) {
  store.setInformationTooltipParameters(true, { orientation: "left", x: event.clientX, y: event.clientY }, { title, text })
}
function removeInformationTooltip () {
  store.setInformationTooltipParameters(false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.color)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "legend-marker mr-2",
            style: _normalizeStyle({ backgroundColor: _ctx.color})
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.iconName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: `./basemaps-icons/${_ctx.iconName}`,
              alt: ""
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", {
        for: _ctx.id,
        class: "text-xs label-color"
      }, _toDisplayString(_ctx.title), 9, _hoisted_5),
      (_ctx.tooltip)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            class: "more-information-button ml-1",
            src: _imports_0,
            alt: "",
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (setInformationTooltip($event, _ctx.tooltip[0], _ctx.tooltip[1]))),
            onMouseleave: removeInformationTooltip
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    (_ctx.switchable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("input", {
            type: "checkbox",
            name: _ctx.id,
            id: _ctx.id,
            class: "toggle-checkbox absolute block w-3 h-3 rounded-full bg-white border-2 appearance-none cursor-pointer",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (toggle(_ctx.id))),
            checked: _ctx.checked
          }, null, 40, _hoisted_7),
          _createElementVNode("label", {
            for: _ctx.id,
            class: "toggle-label block overflow-hidden h-3 rounded-full bg-gray-300 cursor-pointer"
          }, null, 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})